import React from "react";
import { getValueFromInput } from "util/FormsUtils";
import { Input } from "components/bootstrap";
const BooleanField = ({ autoFocus = false, field, onChange, title, typeName, value = false }) => {
  const handleChange = (event) => {
    const nextValue = getValueFromInput(event.target);
    onChange(title, Boolean(nextValue));
  };
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `${typeName}-${title}`,
      name: `configuration[${title}]`,
      type: "checkbox",
      label: field.human_name,
      checked: value,
      help: field.description,
      onChange: handleChange,
      autoFocus
    }
  );
};
export default BooleanField;
